/**
 * Block Resource Display.
 */
import $ from 'jquery';
import 'slick-carousel';
import { breakpoints } from './variables';
import { forceLazyLoad } from '../global/helpers';

const $resourceSliders = $('.em-resource-display__content');
const resourceDisplay = () => {
	window.requestAnimationFrame(() => {
		if ($resourceSliders.length > 0) {
			if (breakpoints.md.aboveMin()) {
				if ($resourceSliders.hasClass('slick-initialized')) {
					$resourceSliders.slick('unslick');
				}
			} else {
				// Force images to lazy load.
				forceLazyLoad($resourceSliders);

				$resourceSliders.not('.slick-initialized').slick({
					slidesToShow: 2,
					lazyLoad: 'progressive',
					dots: false,
					arrows: true,
					rows: 0,
					responsive: [
						{
							breakpoint: breakpoints.xs.max,
							settings: {
								slidesToShow: 1,
							},
						},
					],
				});
			}
		}
	});
};
document.addEventListener('DOMContentLoaded', resourceDisplay);
window.addEventListener('resize', resourceDisplay);
